export default __webpack_public_path__ + "static/media/menu-orders-icon.202add68.svg";